function maintenanceModule (FilterApi) {

	__ = null

	this.render = function () {
		__ = this
		if (!$('#maintenance-video-list').length) {
			/**
			 * Overview page
			 */
			__.filterListener()
			return
		}

		if (window.location.hash) {
			__.scrollToActiveVideo(window.location.hash, true)
		}

		$('[data-mm-set-hash]').on('click', function () {
			window.location.hash = $(this).attr('data-mm-set-hash');
		})
	}

	this.filterListener = function () {
		FilterApi.setRoute('/maintenance')
		FilterApi.changeListener('.js-maintenance-filter-listener')
	}

	this.scrollToActiveVideo = function (hash, autostart = false) {

		var $course_wrapper = $(hash).parents('.course-category')
		var toggle_targer = $course_wrapper.attr('id')
		$('[data-target="#' + toggle_targer + '"]').removeClass('collapsed')
		$('#' + toggle_targer).addClass('show')
		$(hash).parents('.course-item-wrapper').addClass('bg-soft-success')

        if (!toggle_targer) {
            toggle_targer = hash.substring(1)
        }

		$('html, body').animate({
            scrollTop: ($("#" + toggle_targer).offset().top) - 200
        }, 400);

        setTimeout(function() {
	    	$('.bg-soft-success').find('a').trigger('click')
	    }, 500);
	}
}

module.exports = maintenanceModule
